@if ((bannerId$ | async) && !isInTheMiddleOfProcess) {
  <bdo-large-popup
    [isVisible]="showDelayed$ | async"
    [isSolid]="true"
    (closePopupEvent)="closeAndDismiss()">
    <bdo-campaign-tile
      [mode]="CampaignTileType.POPUP"
      [showDismissCheckbox]="true"
      [campaign]="campaign"
      [dismissIsChecked]="dismissIsChecked"
      (clickDismissCheckbox)="onClickCheckbox()"
      (clickCampaignButton)="onClickCampaignButton()"
      >
    </bdo-campaign-tile>
  </bdo-large-popup>
}
